import { render, staticRenderFns } from "./BatchMerchantUpdate.vue?vue&type=template&id=903b9d58&scoped=true&"
import script from "./BatchMerchantUpdate.vue?vue&type=script&lang=js&"
export * from "./BatchMerchantUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903b9d58",
  null
  
)

export default component.exports